import Axios, { AxiosError, AxiosRequestConfig } from "axios";
import { apiLogger } from "../workers/helpers";
import AxiosService from "../axiosService";
import config from "@src/utilities/config";

// Define a namespace for the service
const NAMESPACE = "WBS API Axios Service";

// Initialize AxiosService with configuration
export const axiosAPIClient = new AxiosService(`${config.api.wbs}/`, apiLogger, NAMESPACE, true);

// Expose the configured Axios instance
export const AXIOS_INSTANCE = axiosAPIClient.getAxiosInstance();

/**
 * Custom Axios instance to handle requests.
 * @param {AxiosRequestConfig} config - Axios request configuration.
 * @param {AxiosRequestConfig} [options] - Optional additional request options.
 * @returns {Promise<T>} - A promise resolving to the response data of type T.
 */
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = Axios.CancelToken.source();

  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data }) => data as T);

  // Adding cancel method to the promise
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

// Define a generic type for Axios errors
export type ErrorType<Error> = AxiosError<Error>;

// Define a generic type for response body data
export type BodyType<BodyData> = BodyData;
